export default __webpack_public_path__ + "static/shape_heart_male-a8203c3a9a6933f287164a357b97c22c.png";